import React from 'react'

function Services() {
  return (
    <div>
      <h1>Services</h1>
      <p>s a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text</p>
      </div>
  )
}

export default Services